import script from "./AllCampaign.vue?vue&type=script&setup=true&lang=js"
export * from "./AllCampaign.vue?vue&type=script&setup=true&lang=js"

import "./AllCampaign.vue?vue&type=style&index=0&id=052cd4f4&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-052cd4f4"]])

export default __exports__